import React, { ButtonHTMLAttributes, PropsWithChildren } from 'react'
import styles from '@/components/Button/Button.module.scss'
import { clsx } from 'clsx'

type ButtonProps = PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>> & {
  onClick: () => void
}

const Button = ({ children, className, onClick, ...props }: ButtonProps) => {
  return (
    <button onClick={onClick} className={clsx(styles.btn, className)} {...props}>
      {children}
    </button>
  )
}

export default Button
